const getClientTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    const offsetMinutes = -(new Date().getTimezoneOffset());

    return {
        timezone,
        offsetMinutes,
    };
};

export const getTimezoneHeaders = () => {
    const { timezone, offsetMinutes } = getClientTimezone();

    return {
        "X-Client-Timezone": timezone,
        "X-Client-Utc-Offset": String(offsetMinutes),
    };
};

export default getClientTimezone;
